import SupervisionMenu from './SupervisionMenu.vue'
export default SupervisionMenu
